export const BOT = 'BOT';
export const HUMAN = 'HUMAN';